export function AuthLogo() {
  return (
    <div className="flex flex-col items-center gap-3 mb-8">
      <div className="flex items-center gap-3">
        <svg width="24" height="28" viewBox="0 0 16 18">
          <rect x="0" y="0" width="5" height="18" rx="3" fill="var(--color-accent)" />
          <rect x="8" y="0" width="5" height="18" rx="3" fill="var(--color-accent)" />
        </svg>
        <div>
          <div className="text-lg font-bold text-text-bright font-body tracking-[2px]">ARCANUM</div>
          <div className="text-micro text-accent font-mono tracking-[2.5px] mt-[-2px]">AI UNDERWRITING</div>
        </div>
      </div>
    </div>
  );
}
